import { __require as requireStringifier } from "./stringifier.js";
var stringify_1;
var hasRequiredStringify;
function requireStringify() {
  if (hasRequiredStringify) return stringify_1;
  hasRequiredStringify = 1;
  let Stringifier = requireStringifier();
  function stringify(node, builder) {
    let str = new Stringifier(builder);
    str.stringify(node);
  }
  stringify_1 = stringify;
  stringify.default = stringify;
  return stringify_1;
}
export {
  requireStringify as __require
};
//# sourceMappingURL=stringify.js.map
